import "./Cits.scss";
import MyTabCits from "../../components/MyTabCits";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { useState, useRef, useEffect } from "react";
import axios from "axios";
import Pagination from "react-js-pagination";
import "../../components/MyTabCits.scss";
function Cits() {
  let navigate = useNavigate();
  const [menuData, setMenuData] = useState([]);
  // 페이지네이션
  const [getData, setGetData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  const handlePageChange = (page) => {
    setPage(page);
  };
  // 검색필터 데이터
  const [workflowName, setWorkflowName] = useState("");
  const [taskGroupType, setTaskGroupType] = useState("");
  const [numType, setNumType] = useState("");

  const [acceptNum, setAcceptNum] = useState("");
  const [acceptDate, setAcceptDate] = useState("");

  const [category, setCategory] = useState(0);
  const heighL = useRef();
  const btnWidth = useRef();
  useEffect(() => {
    heighL.current.style.width = btnWidth.current.offsetWidth + "px";
    heighL.current.style.height = btnWidth.current.offsetHeight + "px";
  }, []);

  useEffect(() => {
    getMyData();
  }, [category, page]);

  function sliding(val) {
    resetHandler();
    setPage(1);
    heighL.current.style.left = val + "px";
  }
  const getMyData = async () => {
    let params = {
      pageNumber: page,
      pageSize: 15,
      category: category,
      workflowId: workflowName,
      taskGroupType: taskGroupType,
      acceptDate: acceptDate,
      notState: 0,
      sortField: "createAt",
      sortOrder: "dsc",
    };
    if (numType === "2") {
      params.qualificationNum = acceptNum;
    } else {
      params.acceptNumLike = acceptNum;
    }
    try {
      const response = await axios.get("/api/apply-proc", { params: params });
      setGetData(response.data.data);
      setTotalItems(response.data.recordsFiltered);
      const response2 = await axios.get("/api/workflow", {
        params: { category: category },
      });
      setMenuData(response2.data.data);
    } catch (err) {
      console.log(err);
    }
  };

  const inputHandler = (event) => {
    const eventName = event.target.name;
    if (eventName === "registNum") {
      setAcceptNum(event.target.value);
    }
    if (eventName === "startDate") {
      setAcceptDate(event.target.value);
    }
  };

  const selectHandler = (event) => {
    const eventName = event.target.name;
    if (eventName === "select1") {
      setWorkflowName(event.target.value);
    }
    if (eventName === "select2") {
      setTaskGroupType(event.target.value);
    }
    if (eventName === "select3") {
      setNumType(event.target.value);
    }
  };

  const resetHandler = () => {
    setWorkflowName("");
    setTaskGroupType("");
    setAcceptNum("");
    setAcceptDate("");
  };
  return (
    <>
      {/* <Link to="/breakdown/cits/mytabcits">C-ITS인증</Link>
      <Link to="/breakdown/cits/mytabcits2">시험소인정</Link>
      <Link to="/breakdown/cits/mytabcits3">AVI, VDS 성능평가</Link> */}

      <div className="tab_btns_wrap">
        <div className="tab_btns">
          <Link
            to="/breakdown/cits"
            className="tabBtn"
            ref={btnWidth}
            onClick={() => {
              sliding(0);
              setCategory(0);
            }}
          >
            인증서비스
          </Link>
          <Link
            to="/breakdown/cits"
            className="tabBtn"
            ref={btnWidth}
            onClick={() => {
              sliding(btnWidth.current.offsetWidth);
              setCategory(1);
            }}
          >
            인정서비스
          </Link>

          <Link
            to="/breakdown/cits"
            className="tabBtn"
            ref={btnWidth}
            onClick={() => {
              sliding(btnWidth.current.offsetWidth * 2);
              setCategory(2);
            }}
          >
            시험서비스
          </Link>
          <Link
            to="/breakdown/cits"
            className="tabBtn"
            ref={btnWidth}
            onClick={() => {
              sliding(btnWidth.current.offsetWidth * 3);
              setCategory(3);
            }}
          >
            민간지원서비스
          </Link>
        </div>
        <span ref={heighL} className="hL"></span>
      </div>
      <div className="customcenter_area">
        <section className="customcenter_title_row">
          <div className="customcenter_title_col">
            <div className="select_box select_box_first">
              <select
                name="select1"
                value={workflowName}
                onChange={selectHandler}
              >
                <option value="">심사구분</option>
                {menuData.map((e) => {
                  return (
                    <option key={e.id} value={e.id}>
                      {e.name}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="select_box_contain">
              <div className="select_box select_box_first">
                <select
                  name="select2"
                  value={taskGroupType}
                  onChange={selectHandler}
                >
                  <option value="">신청구분</option>
                  <option value="1">신규</option>
                  <option value="2">정기심사</option>
                  <option value="3">재평가</option>
                  <option value="4">추가</option>
                  <option value="5">변경</option>
                  <option value="6">재발급</option>
                  <option value="7">지위승계</option>
                  <option value="9">이의불만분쟁</option>
                </select>
              </div>
            </div>
          </div>
        </section>
        <section className="input_area">
          <div className="select_box_contain">
            <div
              className="select_box select_box_first"
              style={{ width: "200px" }}
            >
              <select
                name="select3"
                style={{ width: "100%" }}
                value={numType}
                onChange={selectHandler}
              >
                <option value="1">접수번호</option>
                <option value="2">인증번호</option>
              </select>
            </div>
          </div>
          <div className="input_wrap">
            <input
              className="input_line"
              type="text"
              name="registNum"
              value={acceptNum}
              onChange={inputHandler}
              placeholder="접수/인증번호를 입력하세요."
            />
          </div>
          <div className="input_wrap input_date">
            {/* <label htmlFor="start" style={{ wordBreak: "keep-all" }}>
              시작일
            </label> */}
            <input
              id="start"
              name="startDate"
              value={acceptDate}
              onChange={inputHandler}
              className="input_line"
              type="date"
            />
          </div>
          <section className="select_box_area">
            <div className="select_box_btns_wrap" style={{ marginLeft: "1vw" }}>
              <button type="button" className="btn_line" onClick={resetHandler}>
                초기화
              </button>
              <button
                type="button"
                onClick={() => {
                  getMyData();
                  setPage(1);
                }}
                className="btn_color"
              >
                검색
              </button>
            </div>
          </section>
        </section>
      </div>
      <MyTabCits getData={getData} menuData={menuData} category={category} />
      <div className="pagination_wrap">
        <div></div>

        <div className="pagination">
          <Pagination
            activePage={page}
            itemsCountPerPage={15}
            totalItemsCount={totalItems}
            pageRangeDisplayed={15}
            onChange={handlePageChange}
            prevPageText={"‹"}
            nextPageText={"›"}
          />
        </div>
        <div>
          <button
            onClick={(e) => {
              e.preventDefault();
              navigate("/breakdown/cits");
            }}
            className="list_btn"
          >
            목록
          </button>
        </div>
      </div>
    </>
  );
}

export default Cits;
